/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-prototype-builtins */
export function deepMerge<T>(target: T, ...sources: any[]): T {
  if (typeof target !== "object" || target === null) {
    throw new Error("Target must be an object");
  }

  for (const source of sources) {
    if (typeof source !== "object" || source === null) {
      continue;
    }

    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        if (
          //@ts-ignore
          target.hasOwnProperty(key) &&
          typeof (target as any)[key] === "object" &&
          (target as any)[key] !== null
        ) {
          (target as any)[key] = deepMerge((target as any)[key], source[key]);
        } else {
          (target as any)[key] = source[key];
        }
      }
    }
  }

  return target;
}

export function safeParseJSON<T>(raw: unknown): T | null {
  if (typeof raw !== "string") return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}
